export const VENUE_DETAIL = 'venue/detail';
